export default {
  'menu.welcome': '欢迎您',
  'menu.distributor': '经销商管理',
  'menu.distributor.distributor': '经销商管理',
  'menu.distributor.self-allocate': '自分配配额',
  'menu.distributor.quota': '配额记录',
  'menu.distributor.ai-points-record': '灵丌AI积分记录',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '用户管理页',
  'menu.dashboard': '数据纵览',
  'menu.admin.userlist': '用户清单',
  'menu.admin.activationcode': '激活码管理',
  'menu.admin.ai-course-activationcode': 'AI课程激活码管理',
  'menu.teach': '教学',
  'menu.myQrCODE': '二维码管理',
  'menu.teach.student': '学生管理',
  'menu.teach.班级AI提示词': '班级AI提示词',
  'menu.results': '排行榜',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.competition.ssn2025': '蜀少年2026绑定管理',
  'menu.ai': '灵丌AI课程开通',
  'menu.ai.course': '灵丌AI课程管理',
  'menu.ai.course.category': '灵丌AI课程体系列表',
  'menu.ai.course.semester': '灵丌AI课程学期',
  'menu.ai.course.courseware': '灵丌AI课件内容管理',
  'menu.ai.course.school-activate': '灵丌AI课程开通',
  'menu.ai.course.assign': '分配班级课程',
  'menu.ai.points.pricing-rules': '灵丌AI积分计价规则',
  'menu.ai.points.price-settings': '灵丌AI积分包价格设置',
  'menu.ai.membership-price-settings': '灵丌编程会员价格设置',
  'menu.ai.points.transactions': '灵丌AI积分流水',
  'menu.ai.roles.system': '灵丌AI系统角色管理',
  'menu.ai.works.review': '灵丌AI作品审核',
  'menu.管理.灵丌订单管理': '灵丌订单管理',
  'menu.赛事活动': '赛事活动',
};
